module.exports = "https://www.gc-pro.gnp.com.mx/1b7afc394af9b2b357ae7e344a6c4bb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-video-14.png
// module id = 941
// module chunks = 0 1